__turbopack_context__.v({
  "dealsBanner": "ProductBuyZone-module-scss-module__YUaIHq__dealsBanner",
  "dealsBannerContainer": "ProductBuyZone-module-scss-module__YUaIHq__dealsBannerContainer",
  "klarna": "ProductBuyZone-module-scss-module__YUaIHq__klarna",
  "lowInventoryAndAlby": "ProductBuyZone-module-scss-module__YUaIHq__lowInventoryAndAlby",
  "qcTeaser": "ProductBuyZone-module-scss-module__YUaIHq__qcTeaser",
  "quantityAndLowInventory": "ProductBuyZone-module-scss-module__YUaIHq__quantityAndLowInventory",
});
